/**
 * AJAX Taxonomy Filter Block - Front-end JavaScript
 */

document.addEventListener( 'DOMContentLoaded', function () {
	const filterBlocks = document.querySelectorAll(
		'.telex-ajax-filter-wrapper'
	);

	filterBlocks.forEach( function ( block ) {
		const select = block.querySelector( '.telex-ajax-filter-select' );
		const grid = block.querySelector( '.telex-ajax-filter-grid' );
		const loadMoreBtn = block.querySelector(
			'.telex-ajax-filter-button'
		);

		if ( ! select || ! grid ) {
			return;
		}

		const postType = block.dataset.postType;
		const taxonomy = block.dataset.taxonomy;
		const postsPerPage = parseInt( block.dataset.postsPerPage, 10 );
		const nonce = block.dataset.nonce;

		let currentPage = 1;
		let maxPages = parseInt( block.dataset.maxPages, 10 );
		let currentTerm = '';

		// Handle taxonomy filter change
		select.addEventListener( 'change', function () {
			currentTerm = this.value;
			currentPage = 1;
			loadPosts( true );
		} );

		// Handle load more button click
		if ( loadMoreBtn ) {
			loadMoreBtn.addEventListener( 'click', function () {
				currentPage++;
				loadPosts( false );
			} );
		}

		// Function to load posts via AJAX
		function loadPosts( replace ) {
			if ( loadMoreBtn ) {
				loadMoreBtn.classList.add( 'loading' );
				loadMoreBtn.disabled = true;
			}

			// Add loading class to grid
			grid.style.opacity = '0.5';

			const formData = new FormData();
			formData.append( 'action', 'telex_ajax_filter_load_posts' );
			formData.append( 'nonce', nonce );
			formData.append( 'post_type', postType );
			formData.append( 'taxonomy', taxonomy );
			formData.append( 'term_id', currentTerm );
			formData.append( 'paged', currentPage );
			formData.append( 'posts_per_page', postsPerPage );

			fetch( telexAjaxFilter.ajaxurl, {
				method: 'POST',
				credentials: 'same-origin',
				body: formData,
			} )
				.then( function ( response ) {
					return response.json();
				} )
				.then( function ( data ) {
					if ( data.success ) {
						if ( replace ) {
							grid.innerHTML = data.data.html;
						} else {
							grid.insertAdjacentHTML(
								'beforeend',
								data.data.html
							);
						}

						maxPages = data.data.max_pages;

						// Update load more button visibility
						if ( loadMoreBtn ) {
							if ( currentPage >= maxPages ) {
								loadMoreBtn.style.display = 'none';
							} else {
								loadMoreBtn.style.display = 'inline-block';
							}
						}

						// Show no results message if needed
						if ( data.data.html.trim() === '' && replace ) {
							grid.innerHTML =
								'<div class="telex-ajax-filter-no-results">No posts found.</div>';
							if ( loadMoreBtn ) {
								loadMoreBtn.style.display = 'none';
							}
						}
					}
				} )
				.catch( function ( error ) {
					console.error( 'Error loading posts:', error );
				} )
				.finally( function () {
					grid.style.opacity = '1';
					if ( loadMoreBtn ) {
						loadMoreBtn.classList.remove( 'loading' );
						loadMoreBtn.disabled = false;
					}
				} );
		}
	} );
} );